// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V21H23V3ZM15 10.0476L16 9.33979V8H18V9.59847C18 10.0852 17.7638 10.5416 17.3666 10.8228L15.7034 12L17.3666 13.1772C17.7638 13.4584 18 13.9148 18 14.4015V16H16V14.6602L15 13.9524V16H13V8H15V10.0476ZM7 11.4286H9V8H11V16H9V13.4286H7C5.89543 13.4286 5 12.5331 5 11.4286V8H7V11.4286Z"}}]};

const Screen4KFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'screen-4k-filled',
    ref,
    icon: element,
  },
));

Screen4KFilledIcon.displayName = 'Screen4KFilledIcon';

export default Screen4KFilledIcon;
